export const DEFAULT_COST_CODES = [
    {
        code_number: '01-000',
        description: 'Purpose',
        division_name: '01 - General Requirements',
    },
    {
        code_number: '01-002',
        description: 'Instructions',
        division_name: '01 - General Requirements',
    },
    {
        code_number: '01-010',
        description: 'Project Manager',
        division_name: '01 - General Requirements',
    },
    {
        code_number: '01-011',
        description: 'Project Engineer',
        division_name: '01 - General Requirements',
    },
    {
        code_number: '01-012',
        description: 'Superintendent',
        division_name: '01 - General Requirements',
    },
    {
        code_number: '01-013',
        description: 'Project Coordinator',
        division_name: '01 - General Requirements',
    },
    {
        code_number: '01-014',
        description: 'Project Executive',
        division_name: '01 - General Requirements',
    },
    {
        code_number: '01-500',
        description: 'Temporary Facilities and Controls',
        division_name: '01 - General Requirements',
    },
    {
        code_number: '01-510',
        description: 'Temporary Utilities',
        division_name: '01 - General Requirements',
    },
    {
        code_number: '01-511',
        description: 'Temporary Electricity',
        division_name: '01 - General Requirements',
    },
    {
        code_number: '01-514',
        description: 'Temporary Heating, Cooling, and Ventilation',
        division_name: '01 - General Requirements',
    },
    {
        code_number: '01-515',
        description: 'Temporary Lighting',
        division_name: '01 - General Requirements',
    },
    {
        code_number: '01-517',
        description: 'Temporary Telephone',
        division_name: '01 - General Requirements',
    },
    {
        code_number: '01-520',
        description: 'Construction Facilities',
        division_name: '01 - General Requirements',
    },
    {
        code_number: '01-523',
        description: 'Sanitary Facilities',
        division_name: '01 - General Requirements',
    },
    {
        code_number: '01-530',
        description: 'Temporary Construction',
        division_name: '01 - General Requirements',
    },
    {
        code_number: '01-540',
        description: 'Construction Aids',
        division_name: '01 - General Requirements',
    },
    {
        code_number: '01-542',
        description: 'Construction Scaffolding and Platforms',
        division_name: '01 - General Requirements',
    },
    {
        code_number: '01-550',
        description: 'Vehicular Access and Parking',
        division_name: '01 - General Requirements',
    },
    {
        code_number: '01-560',
        description: 'Temporary Barriers and Enclosures',
        division_name: '01 - General Requirements',
    },
    {
        code_number: '01-570',
        description: 'Temporary Controls',
        division_name: '01 - General Requirements',
    },
    {
        code_number: '01-580',
        description: 'Project Identification',
        division_name: '01 - General Requirements',
    },
    {
        code_number: '01-600',
        description: 'Product Requirements (Scope of Work)',
        division_name: '01 - General Requirements',
    },
    {
        code_number: '01-630',
        description: 'Product Substitution Procedures',
        division_name: '01 - General Requirements',
    },
    {
        code_number: '01-640',
        description: 'Owner Furnished Products',
        division_name: '01 - General Requirements',
    },
    {
        code_number: '01-700',
        description: 'Execution Requirements',
        division_name: '01 - General Requirements',
    },
    {
        code_number: '01-712',
        description: 'Local Conditions',
        division_name: '01 - General Requirements',
    },
    {
        code_number: '01-740',
        description: 'Cleaning',
        division_name: '01 - General Requirements',
    },
    {
        code_number: '01-760',
        description: 'Protecting Installed Construction',
        division_name: '01 - General Requirements',
    },
    {
        code_number: '01-903',
        description: 'Hazardous Materials Abatement',
        division_name: '01 - General Requirements',
    },
    {
        code_number: '01-904',
        description: 'Hazardous Materials Removal and Disposal',
        division_name: '01 - General Requirements',
    },
    {
        code_number: '02-000',
        description: 'General',
        division_name: '02 - Site Construction',
    },
    {
        code_number: '02-200',
        description: 'Site Preparation',
        division_name: '02 - Site Construction',
    },
    {
        code_number: '02-220',
        description: 'Site Demolition',
        division_name: '02 - Site Construction',
    },
    {
        code_number: '02-230',
        description: 'Site Clearing',
        division_name: '02 - Site Construction',
    },
    {
        code_number: '02-240',
        description: 'Dewatering',
        division_name: '02 - Site Construction',
    },
    {
        code_number: '02-250',
        description: 'Shoring and Underpinning',
        division_name: '02 - Site Construction',
    },
    {
        code_number: '02-260',
        description: 'Excavation Support and Protection',
        division_name: '02 - Site Construction',
    },
    {
        code_number: '02-300',
        description: 'Earthwork',
        division_name: '02 - Site Construction',
    },
    {
        code_number: '02-310',
        description: 'Grading',
        division_name: '02 - Site Construction',
    },
    {
        code_number: '02-311',
        description: 'Final Grading',
        division_name: '02 - Site Construction',
    },
    {
        code_number: '02-312',
        description: 'Rough Grading',
        division_name: '02 - Site Construction',
    },
    {
        code_number: '02-315',
        description: 'Excavation',
        division_name: '02 - Site Construction',
    },
    {
        code_number: '02-316',
        description: 'Backfilling',
        division_name: '02 - Site Construction',
    },
    {
        code_number: '02-317',
        description: 'Select Borrow',
        division_name: '02 - Site Construction',
    },
    {
        code_number: '02-320',
        description: 'Excavation and Fill',
        division_name: '02 - Site Construction',
    },
    {
        code_number: '02-362',
        description: 'Termite Control',
        division_name: '02 - Site Construction',
    },
    {
        code_number: '02-370',
        description: 'Erosion and Sedimentation Control',
        division_name: '02 - Site Construction',
    },
    {
        code_number: '02-500',
        description: 'Utility Services',
        division_name: '02 - Site Construction',
    },
    {
        code_number: '02-540',
        description: 'Septic Tank',
        division_name: '02 - Site Construction',
    },
    {
        code_number: '02-621',
        description: 'Foundation Drainage Piping',
        division_name: '02 - Site Construction',
    },
    {
        code_number: '02-625',
        description: 'Retaining Wall Drainage Piping',
        division_name: '02 - Site Construction',
    },
    {
        code_number: '02-740',
        description: 'Flexible Pavement Asphalt Pavement',
        division_name: '02 - Site Construction',
    },
    {
        code_number: '02-750',
        description: 'Concrete Pads and Walks',
        division_name: '02 - Site Construction',
    },
    {
        code_number: '02-770',
        description: 'Curb and Gutters',
        division_name: '02 - Site Construction',
    },
    {
        code_number: '02-780',
        description: 'Clay Unit Pavers',
        division_name: '02 - Site Construction',
    },
    {
        code_number: '02-781',
        description: 'Asphalt Pavers',
        division_name: '02 - Site Construction',
    },
    {
        code_number: '02-782',
        description: 'Brick Pavers',
        division_name: '02 - Site Construction',
    },
    {
        code_number: '02-783',
        description: 'Interlocking Concrete Unit Paving',
        division_name: '02 - Site Construction',
    },
    {
        code_number: '02-784',
        description: 'Stone Unit Pavers',
        division_name: '02 - Site Construction',
    },
    {
        code_number: '02-790',
        description: 'Athletic Surfacing',
        division_name: '02 - Site Construction',
    },
    {
        code_number: '02-795',
        description: 'Porous Paving',
        division_name: '02 - Site Construction',
    },
    {
        code_number: '02-800',
        description: 'Site Amenities',
        division_name: '02 - Site Construction',
    },
    {
        code_number: '02-812',
        description: 'Drip Irrigation',
        division_name: '02 - Site Construction',
    },
    {
        code_number: '02-813',
        description: 'Lawn Sprinkling and Irrigation',
        division_name: '02 - Site Construction',
    },
    {
        code_number: '02-815',
        description: 'Fountains',
        division_name: '02 - Site Construction',
    },
    {
        code_number: '02-820',
        description: 'Fences and Gates',
        division_name: '02 - Site Construction',
    },
    {
        code_number: '02-821',
        description: 'Chain Link Fences',
        division_name: '02 - Site Construction',
    },
    {
        code_number: '02-822',
        description: 'Ornamental Metal Fences and Gates',
        division_name: '02 - Site Construction',
    },
    {
        code_number: '02-823',
        description: 'PVC Fences and Gates',
        division_name: '02 - Site Construction',
    },
    {
        code_number: '02-824',
        description: 'Wire Fences and Gates',
        division_name: '02 - Site Construction',
    },
    {
        code_number: '02-825',
        description: 'Wood Fences and Gates',
        division_name: '02 - Site Construction',
    },
    {
        code_number: '02-830',
        description: 'Retaining Walls',
        division_name: '02 - Site Construction',
    },
    {
        code_number: '02-850',
        description: 'Bridges/Footbridges',
        division_name: '02 - Site Construction',
    },
    {
        code_number: '02-870',
        description: 'Sculpture/Ornamental',
        division_name: '02 - Site Construction',
    },
    {
        code_number: '02-900',
        description: 'Landscaping',
        division_name: '02 - Site Construction',
    },
    {
        code_number: '02-915',
        description: 'Mulch',
        division_name: '02 - Site Construction',
    },
    {
        code_number: '02-917',
        description: 'Soil Preparation',
        division_name: '02 - Site Construction',
    },
    {
        code_number: '02-919',
        description: 'Topsoil',
        division_name: '02 - Site Construction',
    },
    {
        code_number: '02-923',
        description: 'Seeding and Soil Supplements',
        division_name: '02 - Site Construction',
    },
    {
        code_number: '02-924',
        description: 'Sodding',
        division_name: '02 - Site Construction',
    },
    {
        code_number: '02-930',
        description: 'Exterior Plants',
        division_name: '02 - Site Construction',
    },
    {
        code_number: '02-932',
        description: 'Plants and Bulbs',
        division_name: '02 - Site Construction',
    },
    {
        code_number: '02-935',
        description: 'Plant Maintenance',
        division_name: '02 - Site Construction',
    },
    {
        code_number: '02-936',
        description: 'Fertilizer',
        division_name: '02 - Site Construction',
    },
    {
        code_number: '03-000',
        description: 'General',
        division_name: '03 - Concrete',
    },
    {
        code_number: '03-050',
        description: 'Concrete Subcontractor',
        division_name: '03 - Concrete',
    },
    {
        code_number: '03-100',
        description: 'Concrete Reinforcement',
        division_name: '03 - Concrete',
    },
    {
        code_number: '03-210',
        description: 'Cast-In-Place Concrete',
        division_name: '03 - Concrete',
    },
    {
        code_number: '03-230',
        description: 'Anchor Bolts',
        division_name: '03 - Concrete',
    },
    {
        code_number: '03-300',
        description: 'Footings',
        division_name: '03 - Concrete',
    },
    {
        code_number: '03-310',
        description: 'Expansion Joints',
        division_name: '03 - Concrete',
    },
    {
        code_number: '03-320',
        description: 'Slab Foundations',
        division_name: '03 - Concrete',
    },
    {
        code_number: '03-330',
        description: 'Poured Concrete Basement Walls',
        division_name: '03 - Concrete',
    },
    {
        code_number: '03-350',
        description: 'Concrete Finishing',
        division_name: '03 - Concrete',
    },
    {
        code_number: '03-400',
        description: 'Precast Concrete',
        division_name: '03 - Concrete',
    },
    {
        code_number: '03-500',
        description: 'Cementitious Decks and Underlayments',
        division_name: '03 - Concrete',
    },
    {
        code_number: '03-600',
        description: 'Grouts',
        division_name: '03 - Concrete',
    },
    {
        code_number: '04-050',
        description: 'Basic Masonry Materials and Methods',
        division_name: '04 - Masonry',
    },
    {
        code_number: '04-200',
        description: 'Masonry Units',
        division_name: '04 - Masonry',
    },
    {
        code_number: '04-400',
        description: 'Stone',
        division_name: '04 - Masonry',
    },
    {
        code_number: '04-500',
        description: 'Refractories',
        division_name: '04 - Masonry',
    },
    {
        code_number: '04-600',
        description: 'Corrosion-Resistant Masonry',
        division_name: '04 - Masonry',
    },
    {
        code_number: '04-700',
        description: 'Simulated Masonry',
        division_name: '04 - Masonry',
    },
    {
        code_number: '04-800',
        description: 'Masonry Assemblies',
        division_name: '04 - Masonry',
    },
    {
        code_number: '04-900',
        description: 'Masonry Restoration and Cleaning',
        division_name: '04 - Masonry',
    },
    {
        code_number: '05-050',
        description: 'Basic Metal Materials and Method',
        division_name: '05 - Metals',
    },
    {
        code_number: '05-100',
        description: 'Structural Metals',
        division_name: '05 - Metals',
    },
    {
        code_number: '05-200',
        description: 'Metal Joists',
        division_name: '05 - Metals',
    },
    {
        code_number: '05-300',
        description: 'Metal Deck',
        division_name: '05 - Metals',
    },
    {
        code_number: '05-400',
        description: 'Cold-Formed Metal Framing',
        division_name: '05 - Metals',
    },
    {
        code_number: '05-500',
        description: 'Metal Fabrications',
        division_name: '05 - Metals',
    },
    {
        code_number: '05-600',
        description: 'Hydraulic Fabrications',
        division_name: '05 - Metals',
    },
    {
        code_number: '05-700',
        description: 'Ornamental Metal',
        division_name: '05 - Metals',
    },
    {
        code_number: '05-800',
        description: 'Erosion Control',
        division_name: '05 - Metals',
    },
    {
        code_number: '05-900',
        description: 'Metal Restoration and Cleaning',
        division_name: '05 - Metals',
    },
    {
        code_number: '06-050',
        description: 'Basic Wood and Plastic Materials and Methods',
        division_name: '06 - Wood and Plastics',
    },
    {
        code_number: '06-100',
        description: 'Rough Carpentry',
        division_name: '06 - Wood and Plastics',
    },
    {
        code_number: '06-200',
        description: 'Finish Carpentry',
        division_name: '06 - Wood and Plastics',
    },
    {
        code_number: '06-400',
        description: 'Architectural Woodwork',
        division_name: '06 - Wood and Plastics',
    },
    {
        code_number: '06-500',
        description: 'Structural Plastics',
        division_name: '06 - Wood and Plastics',
    },
    {
        code_number: '06-600',
        description: 'Plastic Fabrications',
        division_name: '06 - Wood and Plastics',
    },
    {
        code_number: '06-900',
        description: 'Wood and Plastic Restoration and Cleaning',
        division_name: '06 - Wood and Plastics',
    },
    {
        code_number: '07-050',
        description: 'Basic Thermal and Moisture Protection Materials and Methods',
        division_name: '07 - Thermal and Moisture Protection',
    },
    {
        code_number: '07-100',
        description: 'Damproofing and Waterproofing',
        division_name: '07 - Thermal and Moisture Protection',
    },
    {
        code_number: '07-200',
        description: 'Thermal Protection  - Insulation',
        division_name: '07 - Thermal and Moisture Protection',
    },
    {
        code_number: '07-300',
        description: 'Shingles, Roof Tiles, and Roof Coverings',
        division_name: '07 - Thermal and Moisture Protection',
    },
    {
        code_number: '07-400',
        description: 'Roofing and Siding Panels',
        division_name: '07 - Thermal and Moisture Protection',
    },
    {
        code_number: '07-500',
        description: 'Membrane Roofing',
        division_name: '07 - Thermal and Moisture Protection',
    },
    {
        code_number: '07-600',
        description: 'Flashing and Sheet Metal',
        division_name: '07 - Thermal and Moisture Protection',
    },
    {
        code_number: '07-700',
        description: 'Roof Specialties and Accessories',
        division_name: '07 - Thermal and Moisture Protection',
    },
    {
        code_number: '07-800',
        description: 'Fire and Smoke Protection',
        division_name: '07 - Thermal and Moisture Protection',
    },
    {
        code_number: '07-900',
        description: 'Joint Sealers',
        division_name: '07 - Thermal and Moisture Protection',
    },
    {
        code_number: '08-050',
        description: 'Basic Door and Window Materials and Methods',
        division_name: '08 - Doors and Windows',
    },
    {
        code_number: '08-100',
        description: 'Doors',
        division_name: '08 - Doors and Windows',
    },
    {
        code_number: '08-200',
        description: 'Wood and Plastic Doors',
        division_name: '08 - Doors and Windows',
    },
    {
        code_number: '08-300',
        description: 'Specialty Doors',
        division_name: '08 - Doors and Windows',
    },
    {
        code_number: '08-400',
        description: 'Entrances and Storefronts',
        division_name: '08 - Doors and Windows',
    },
    {
        code_number: '08-500',
        description: 'Windows',
        division_name: '08 - Doors and Windows',
    },
    {
        code_number: '08-600',
        description: 'Skylights',
        division_name: '08 - Doors and Windows',
    },
    {
        code_number: '08-700',
        description: 'Hardware',
        division_name: '08 - Doors and Windows',
    },
    {
        code_number: '08-800',
        description: 'Glazing',
        division_name: '08 - Doors and Windows',
    },
    {
        code_number: '08-900',
        description: 'Glazed Curtain Wall',
        division_name: '08 - Doors and Windows',
    },
    {
        code_number: '09-050',
        description: 'Basic Finish Materials and Methods',
        division_name: '09 - Finishes',
    },
    {
        code_number: '09-100',
        description: 'Metal Support Assemblies',
        division_name: '09 - Finishes',
    },
    {
        code_number: '09-250',
        description: 'Gypsum Wallboard',
        division_name: '09 - Finishes',
    },
    {
        code_number: '09-300',
        description: 'Tile',
        division_name: '09 - Finishes',
    },
    {
        code_number: '09-400',
        description: 'Terrazzo',
        division_name: '09 - Finishes',
    },
    {
        code_number: '09-500',
        description: 'Ceilings',
        division_name: '09 - Finishes',
    },
    {
        code_number: '09-600',
        description: 'Flooring',
        division_name: '09 - Finishes',
    },
    {
        code_number: '09-680',
        description: 'Carpet',
        division_name: '09 - Finishes',
    },
    {
        code_number: '09-700',
        description: 'Wall Finishes',
        division_name: '09 - Finishes',
    },
    {
        code_number: '09-800',
        description: 'Acoustical Treatment',
        division_name: '09 - Finishes',
    },
    {
        code_number: '09-900',
        description: 'Paints and Coatings',
        division_name: '09 - Finishes',
    },
    {
        code_number: '10-100',
        description: 'Visual Display Boards',
        division_name: '10 - Specialties',
    },
    {
        code_number: '10-150',
        description: 'Compartments and Cubicles',
        division_name: '10 - Specialties',
    },
    {
        code_number: '10-200',
        description: 'Louvers and Vents',
        division_name: '10 - Specialties',
    },
    {
        code_number: '10-240',
        description: 'Grilles and Screens',
        division_name: '10 - Specialties',
    },
    {
        code_number: '10-250',
        description: 'Service Walls',
        division_name: '10 - Specialties',
    },
    {
        code_number: '10-260',
        description: 'Wall and Corner Guards',
        division_name: '10 - Specialties',
    },
    {
        code_number: '10-270',
        description: 'Access Flooring',
        division_name: '10 - Specialties',
    },
    {
        code_number: '10-290',
        description: 'Pest Control',
        division_name: '10 - Specialties',
    },
    {
        code_number: '10-300',
        description: 'Fireplaces and Stoves',
        division_name: '10 - Specialties',
    },
    {
        code_number: '10-340',
        description: 'Manufactured Exterior Specialties',
        division_name: '10 - Specialties',
    },
    {
        code_number: '10-350',
        description: 'Flagpoles',
        division_name: '10 - Specialties',
    },
    {
        code_number: '10-400',
        description: 'Identification Devices',
        division_name: '10 - Specialties',
    },
    {
        code_number: '10-450',
        description: 'Pedestrian Control Devices',
        division_name: '10 - Specialties',
    },
    {
        code_number: '10-500',
        description: 'Lockers',
        division_name: '10 - Specialties',
    },
    {
        code_number: '10-520',
        description: 'Fire Protection Specialties',
        division_name: '10 - Specialties',
    },
    {
        code_number: '10-530',
        description: 'Protective Covers',
        division_name: '10 - Specialties',
    },
    {
        code_number: '10-550',
        description: 'Postal Specialties',
        division_name: '10 - Specialties',
    },
    {
        code_number: '10-600',
        description: 'Partitions',
        division_name: '10 - Specialties',
    },
    {
        code_number: '10-670',
        description: 'Storage Shelving',
        division_name: '10 - Specialties',
    },
    {
        code_number: '10-700',
        description: 'Exterior Protection',
        division_name: '10 - Specialties',
    },
    {
        code_number: '10-750',
        description: 'Telephone Specialties',
        division_name: '10 - Specialties',
    },
    {
        code_number: '10-800',
        description: 'Toilet, Bath, and Laundry Specialties',
        division_name: '10 - Specialties',
    },
    {
        code_number: '10-820',
        description: 'Bathroom Accessories',
        division_name: '10 - Specialties',
    },
    {
        code_number: '10-880',
        description: 'Scales',
        division_name: '10 - Specialties',
    },
    {
        code_number: '10-900',
        description: 'Wardrobe and Closet Specialties',
        division_name: '10 - Specialties',
    },
    {
        code_number: '11-010',
        description: 'Maintenance Equipment',
        division_name: '11 - Equipment',
    },
    {
        code_number: '11-020',
        description: 'Security and Vault Equipment',
        division_name: '11 - Equipment',
    },
    {
        code_number: '11-030',
        description: 'Teller and Service Equipment',
        division_name: '11 - Equipment',
    },
    {
        code_number: '11-040',
        description: 'Ecclesiastical Equipment',
        division_name: '11 - Equipment',
    },
    {
        code_number: '11-050',
        description: 'Library Equipment',
        division_name: '11 - Equipment',
    },
    {
        code_number: '11-060',
        description: 'Theater and Stage Equipment',
        division_name: '11 - Equipment',
    },
    {
        code_number: '11-070',
        description: 'Instrumental Equipment',
        division_name: '11 - Equipment',
    },
    {
        code_number: '11-080',
        description: 'Registration Equipment',
        division_name: '11 - Equipment',
    },
    {
        code_number: '11-090',
        description: 'Checkroom Equipment',
        division_name: '11 - Equipment',
    },
    {
        code_number: '11-100',
        description: 'Mercantile Equipment',
        division_name: '11 - Equipment',
    },
    {
        code_number: '11-110',
        description: 'Commercial Laundry and Dry Cleaning Equipment',
        division_name: '11 - Equipment',
    },
    {
        code_number: '11-120',
        description: 'Vending Equipment',
        division_name: '11 - Equipment',
    },
    {
        code_number: '11-130',
        description: 'Audio-Visual Equipment',
        division_name: '11 - Equipment',
    },
    {
        code_number: '11-140',
        description: 'Vehicle Service Equipment',
        division_name: '11 - Equipment',
    },
    {
        code_number: '11-150',
        description: 'Parking Control Equipment',
        division_name: '11 - Equipment',
    },
    {
        code_number: '11-160',
        description: 'Loading Dock Equipment',
        division_name: '11 - Equipment',
    },
    {
        code_number: '11-170',
        description: 'Solid Waste Handling Equipment',
        division_name: '11 - Equipment',
    },
    {
        code_number: '11-190',
        description: 'Detention Equipment',
        division_name: '11 - Equipment',
    },
    {
        code_number: '11-200',
        description: 'Water Supply and Treatment Equipment',
        division_name: '11 - Equipment',
    },
    {
        code_number: '11-280',
        description: 'Hydraulic Gates and Valves',
        division_name: '11 - Equipment',
    },
    {
        code_number: '11-300',
        description: 'Fluid Waste Treatment and Disposal Equipment',
        division_name: '11 - Equipment',
    },
    {
        code_number: '11-400',
        description: 'Food Service Equipment',
        division_name: '11 - Equipment',
    },
    {
        code_number: '11-450',
        description: 'Residential Equipment',
        division_name: '11 - Equipment',
    },
    {
        code_number: '11-460',
        description: 'Unit Kitchens',
        division_name: '11 - Equipment',
    },
    {
        code_number: '11-470',
        description: 'Darkroom Equipment',
        division_name: '11 - Equipment',
    },
    {
        code_number: '11-480',
        description: 'Athletic, Recreational, and Therapeutic Equipment',
        division_name: '11 - Equipment',
    },
    {
        code_number: '11-500',
        description: 'Industrial and Process Equipment',
        division_name: '11 - Equipment',
    },
    {
        code_number: '11-600',
        description: 'Laboratory Equipment',
        division_name: '11 - Equipment',
    },
    {
        code_number: '11-650',
        description: 'Planetarium Equipment',
        division_name: '11 - Equipment',
    },
    {
        code_number: '11-660',
        description: 'Observatory Equipment',
        division_name: '11 - Equipment',
    },
    {
        code_number: '11-680',
        description: 'Office Equipment',
        division_name: '11 - Equipment',
    },
    {
        code_number: '11-700',
        description: 'Medical Equipment',
        division_name: '11 - Equipment',
    },
    {
        code_number: '11-850',
        description: 'Navigation Equipment',
        division_name: '11 - Equipment',
    },
    {
        code_number: '11-870',
        description: 'Agricultural Equipment',
        division_name: '11 - Equipment',
    },
    {
        code_number: '11-900',
        description: 'Exhibit Equipment',
        division_name: '11 - Equipment',
    },
    {
        code_number: '12-050',
        description: 'Fabrics',
        division_name: '12 - Furnishing',
    },
    {
        code_number: '12-100',
        description: 'Art',
        division_name: '12 - Furnishing',
    },
    {
        code_number: '12-300',
        description: 'Manufactured Casework',
        division_name: '12 - Furnishing',
    },
    {
        code_number: '12-400',
        description: 'Furnishing and Accessories',
        division_name: '12 - Furnishing',
    },
    {
        code_number: '12-500',
        description: 'Furniture',
        division_name: '12 - Furnishing',
    },
    {
        code_number: '12-600',
        description: 'Multiple Seating',
        division_name: '12 - Furnishing',
    },
    {
        code_number: '12-700',
        description: 'Systems Furniture',
        division_name: '12 - Furnishing',
    },
    {
        code_number: '12-800',
        description: 'Interior Plants and Planters',
        division_name: '12 - Furnishing',
    },
    {
        code_number: '12-900',
        description: 'Furnishing Restoration and Repair',
        division_name: '12 - Furnishing',
    },
    {
        code_number: '13-010',
        description: 'Air-Supported Structures',
        division_name: '13 - Special Construction',
    },
    {
        code_number: '13-020',
        description: 'Building Modules',
        division_name: '13 - Special Construction',
    },
    {
        code_number: '13-030',
        description: 'Special Purpose Rooms',
        division_name: '13 - Special Construction',
    },
    {
        code_number: '13-090',
        description: 'Radiation Protection',
        division_name: '13 - Special Construction',
    },
    {
        code_number: '13-100',
        description: 'Lightning Protection',
        division_name: '13 - Special Construction',
    },
    {
        code_number: '13-110',
        description: 'Cathodic Protection',
        division_name: '13 - Special Construction',
    },
    {
        code_number: '13-120',
        description: 'Pre-Engineered Structures',
        division_name: '13 - Special Construction',
    },
    {
        code_number: '13-150',
        description: 'Swimming Pools',
        division_name: '13 - Special Construction',
    },
    {
        code_number: '13-160',
        description: 'Aquariums',
        division_name: '13 - Special Construction',
    },
    {
        code_number: '13-165',
        description: 'Aquatic Park Facilities',
        division_name: '13 - Special Construction',
    },
    {
        code_number: '13-170',
        description: 'Tubs and Pools',
        division_name: '13 - Special Construction',
    },
    {
        code_number: '13-175',
        description: 'Ice Rinks',
        division_name: '13 - Special Construction',
    },
    {
        code_number: '13-185',
        description: 'Kennels and Animal Shelters',
        division_name: '13 - Special Construction',
    },
    {
        code_number: '13-190',
        description: 'Site-Constructed Incinerators',
        division_name: '13 - Special Construction',
    },
    {
        code_number: '13-200',
        description: 'Storage Tanks',
        division_name: '13 - Special Construction',
    },
    {
        code_number: '13-220',
        description: 'Filter Underdrains and Media',
        division_name: '13 - Special Construction',
    },
    {
        code_number: '13-230',
        description: 'Digester Covers and Appurtenances',
        division_name: '13 - Special Construction',
    },
    {
        code_number: '13-240',
        description: 'Oxygenation Systems',
        division_name: '13 - Special Construction',
    },
    {
        code_number: '13-260',
        description: 'Sludge Conditioning Systems',
        division_name: '13 - Special Construction',
    },
    {
        code_number: '13-280',
        description: 'Hazardous Material Remediation',
        division_name: '13 - Special Construction',
    },
    {
        code_number: '13-400',
        description: 'Measurement and Control Instrumentation',
        division_name: '13 - Special Construction',
    },
    {
        code_number: '13-500',
        description: 'Recording Instrumentation',
        division_name: '13 - Special Construction',
    },
    {
        code_number: '13-550',
        description: 'Transportatin Control Instrumentation',
        division_name: '13 - Special Construction',
    },
    {
        code_number: '13-600',
        description: 'Solar and Wind Energy Equipment',
        division_name: '13 - Special Construction',
    },
    {
        code_number: '13-700',
        description: 'Security Access and Surveillance',
        division_name: '13 - Special Construction',
    },
    {
        code_number: '13-800',
        description: 'Building Automation and Control',
        division_name: '13 - Special Construction',
    },
    {
        code_number: '13-850',
        description: 'Detection and Alarm',
        division_name: '13 - Special Construction',
    },
    {
        code_number: '13-900',
        description: 'Fire Suppression',
        division_name: '13 - Special Construction',
    },
    {
        code_number: '14-100',
        description: 'Dumbwaiters',
        division_name: '14 - Conveying Systems',
    },
    {
        code_number: '14-200',
        description: 'Elevators',
        division_name: '14 - Conveying Systems',
    },
    {
        code_number: '14-300',
        description: 'Escalators and Moving Walks',
        division_name: '14 - Conveying Systems',
    },
    {
        code_number: '14-400',
        description: 'Lifts',
        division_name: '14 - Conveying Systems',
    },
    {
        code_number: '14-500',
        description: 'Material Handling',
        division_name: '14 - Conveying Systems',
    },
    {
        code_number: '14-600',
        description: 'Hoists and Cables',
        division_name: '14 - Conveying Systems',
    },
    {
        code_number: '14-700',
        description: 'Turntables',
        division_name: '14 - Conveying Systems',
    },
    {
        code_number: '14-800',
        description: 'Scaffolding',
        division_name: '14 - Conveying Systems',
    },
    {
        code_number: '14-900',
        description: 'Transportation',
        division_name: '14 - Conveying Systems',
    },
    {
        code_number: '15-050',
        description: 'Basic Mechanical Materials and Methods',
        division_name: '15 - Mechanical',
    },
    {
        code_number: '15-100',
        description: 'Plumbing',
        division_name: '15 - Mechanical',
    },
    {
        code_number: '15-200',
        description: 'Process Piping',
        division_name: '15 - Mechanical',
    },
    {
        code_number: '15-300',
        description: 'Fire Protection Piping',
        division_name: '15 - Mechanical',
    },
    {
        code_number: '15-400',
        description: 'Plumbing Fixtures and Equipment',
        division_name: '15 - Mechanical',
    },
    {
        code_number: '15-500',
        description: 'Heat-Generation Equipment',
        division_name: '15 - Mechanical',
    },
    {
        code_number: '15-600',
        description: 'Refrigeration Equipment',
        division_name: '15 - Mechanical',
    },
    {
        code_number: '15-700',
        description: 'Heating, Venting, and Air Conditioning',
        division_name: '15 - Mechanical',
    },
    {
        code_number: '15-800',
        description: 'Air Distribution',
        division_name: '15 - Mechanical',
    },
    {
        code_number: '15-900',
        description: 'HVAC Instruments and Controls',
        division_name: '15 - Mechanical',
    },
    {
        code_number: '15-950',
        description: 'Testing, Adjusting, and Balancing',
        division_name: '15 - Mechanical',
    },
    {
        code_number: '16-050',
        description: 'Basic Electrical Materials and Methods',
        division_name: '16 - Electrical',
    },
    {
        code_number: '16-100',
        description: 'Electrical',
        division_name: '16 - Electrical',
    },
    {
        code_number: '16-200',
        description: 'Electrical Power',
        division_name: '16 - Electrical',
    },
    {
        code_number: '16-300',
        description: 'Transmission and Distribution',
        division_name: '16 - Electrical',
    },
    {
        code_number: '16-400',
        description: 'Low-Voltage Distribution',
        division_name: '16 - Electrical',
    },
    {
        code_number: '16-500',
        description: 'Lighting',
        division_name: '16 - Electrical',
    },
    {
        code_number: '16-700',
        description: 'Communications',
        division_name: '16 - Electrical',
    },
    {
        code_number: '16-800',
        description: 'Sound and Video',
        division_name: '16 - Electrical',
    },
    {
        code_number: '17-010',
        description: 'Contingency',
        division_name: '17 - Markup and Contingency',
    },
    {
        code_number: '17-020',
        description: 'Insurance',
        division_name: '17 - Markup and Contingency',
    },
    {
        code_number: '17-030',
        description: 'Bond',
        division_name: '17 - Markup and Contingency',
    },
    {
        code_number: '17-040',
        description: 'Profit',
        division_name: '17 - Markup and Contingency',
    },
];
